import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITransactionType } from "src/models/Stores/Sale.models";

interface TransactionTypesState {
  transactionTypes: ITransactionType[];
  transactionTypeToEdit: ITransactionType | null;
}

const initialState: TransactionTypesState = {
  transactionTypes: [],
  transactionTypeToEdit: null,
};

const transactionTypesSlice = createSlice({
  name: "TransactionTypes",
  initialState,
  reducers: {
    setTransactionTypesList: (
      state,
      action: PayloadAction<ITransactionType[]>
    ) => {
      state.transactionTypes = action.payload;
    },
    concatListTransactionTypes: (
      state: TransactionTypesState,
      action: PayloadAction<ITransactionType[]>
    ) => {
      state.transactionTypes = [
        ...state.transactionTypes.concat(action.payload),
      ];
    },
    setTransactionTypeToEdit: (
      state,
      action: PayloadAction<ITransactionType | null>
    ) => {
      state.transactionTypeToEdit = action.payload;
    },
    addTransactionTypes: (state, action: PayloadAction<ITransactionType>) => {
      state.transactionTypes.push(action.payload);
    },
    updateTransactionTypes: (
      state,
      action: PayloadAction<ITransactionType>
    ) => {
      let itemIndex = state.transactionTypes.findIndex(
        item => item.transactionTypeId === action.payload.transactionTypeId
      );
      if (itemIndex !== -1) state.transactionTypes[itemIndex] = action.payload;
    },
    deleteTransactionTypes: (state, action: PayloadAction<number>) => {
      const newArray = state.transactionTypes.filter(
        item => item.transactionTypeId !== action.payload
      );
      state.transactionTypes = newArray;
    },
  },
});

export const {
  setTransactionTypesList,
  concatListTransactionTypes,
  setTransactionTypeToEdit,
  addTransactionTypes,
  updateTransactionTypes,
  deleteTransactionTypes,
} = transactionTypesSlice.actions;

export default transactionTypesSlice.reducer;
